<script>  
  import Link from '@itslearning/prometheus/assets/Navigation/Link/v1/Link.svelte';
  
  export let title = 'title of the page';
  export let focusHeading = false;
  
  /**
   * Heading level for page. Default 2.
   */
  export let headingLevel = 2;
  /**
   * If header should be displayed. Default true
   */
  export let displayHeading = true;
  /**
   * Position of heading 'aboveContentBlock' | 'insideContentBlock'
   */
  export let headingPosition = 'aboveContentBlock';
  /**
   *  @param {string} backLinkHref. Href to back link.
   */
  export let backLinkHref;
  /**
   *  @param {string} backLinkText. The text in the back link.
   */
  export let backLinkText;

  let header;
  
  $: if (displayHeading && focusHeading && header) {
    header.focus();
    focusHeading = false;
  }
</script>

<svelte:head>
  <title>{title}</title>
</svelte:head>

{#if backLinkHref && backLinkText && headingPosition === 'aboveContentBlock'}
  <Link kind="standalone" iconClass="back-link" href="{backLinkHref}" on:click text="{backLinkText}" />
{/if}

{#if displayHeading && headingPosition === 'aboveContentBlock'}
  <svelte:element bind:this={header} tabindex="-1" this={`h${headingLevel}`}>{title}</svelte:element>
{/if}
<div class="content-block">
  {#if backLinkHref && backLinkText && headingPosition === 'insideContentBlock'}
    <Link kind="standalone" iconClass="back-link" href="{backLinkHref}" on:click text="{backLinkText}" />
  {/if}
  {#if displayHeading && headingPosition === 'insideContentBlock'}
    <svelte:element bind:this={header} tabindex="-1" this={`h${headingLevel}`}>{title}</svelte:element>
  {/if}
<slot />
</div>